import { useApi } from './useApi';
import { apiService } from '../services/api';

interface FaqItem {
  question: string;
  answer: string;
  order: number;
}

interface FaqSectionData {
  title: string;
  description?: string;
  faqItems: FaqItem[];
}

export function useFaqSection() {
  return useApi<FaqSectionData>(apiService.getFaqSection);
} 